import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-why-us',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section id="why-us" class="section why-us">
      <div class="container">
        <div class="section-header text-center">
          <h2 class="section-title">Pourquoi Zero-Waste ?</h2>
          <p class="section-subtitle">
            Notre plateforme offre une solution innovante pour lutter contre le
            gaspillage alimentaire tout en générant des revenus supplémentaires
            pour votre commerce.
          </p>
        </div>

        <div class="benefits">
          <div class="benefit-card">
            <div class="benefit-icon">
              <i class="fas fa-leaf"></i>
            </div>
            <h3>Impact écologique</h3>
            <p>
              Réduisez votre empreinte carbone en évitant que vos invendus ne
              finissent à la poubelle.
            </p>
            <div class="benefit-stat">
              <span class="stat-number">10+</span>
              <span class="stat-text"
                >tonnes de nourriture sauvées chaque jour</span
              >
            </div>
          </div>

          <div class="benefit-card">
            <div class="benefit-icon">
              <i class="fas fa-euro-sign"></i>
            </div>
            <h3>Revenus supplémentaires</h3>
            <p>
              Transformez vos pertes potentielles en gains réels en vendant ce
              qui aurait été jeté.
            </p>
            <div class="benefit-stat">
              <span class="stat-number">15%</span>
              <span class="stat-text"
                >d'augmentation moyenne du chiffre d'affaires</span
              >
            </div>
          </div>

          <div class="benefit-card">
            <div class="benefit-icon">
              <i class="fas fa-users"></i>
            </div>
            <h3>Nouveaux clients</h3>
            <p>
              Attirez une clientèle engagée et soucieuse de l'environnement dans
              votre commerce.
            </p>
            <div class="benefit-stat">
              <span class="stat-number">30%</span>
              <span class="stat-text"
                >de nouveaux clients via notre plateforme</span
              >
            </div>
          </div>
        </div>
      </div>
    </section>
  `,
  styles: [
    `
      .why-us {
        background-color: var(--light-color);
      }

      .section-header {
        margin-bottom: 60px;
      }

      .section-subtitle {
        margin: 0 auto;
      }

      .benefits {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 30px;
        margin-bottom: 60px;
      }

      .benefit-card {
        background-color: var(--gray-color);
        padding: 40px 30px;
        border-radius: 15px;
        text-align: center;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
      }

      .benefit-card:hover {
        transform: translateY(-10px);
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
      }

      .benefit-card::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 5px;
        background-color: var(--primary-color);
        transform: scaleX(0);
        transform-origin: left;
        transition: transform 0.3s ease;
      }

      .benefit-card:hover::before {
        transform: scaleX(1);
      }

      .benefit-icon {
        width: 80px;
        height: 80px;
        background-color: var(--primary-light);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 25px;
      }

      .benefit-icon i {
        font-size: 2rem;
        color: var(--primary-dark);
      }

      .benefit-card h3 {
        font-size: 1.5rem;
        margin-bottom: 15px;
      }

      .benefit-card p {
        color: var(--dark-gray);
        margin-bottom: 20px;
      }

      .benefit-stat {
        background-color: var(--secondary-color);
        padding: 15px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
      }

      .stat-number {
        font-size: 1.8rem;
        font-weight: 700;
        color: var(--primary-color);
      }

      .stat-text {
        font-size: 0.9rem;
        color: var(--dark-gray);
      }

      .impact-counter {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        margin-top: 60px;
        padding: 40px;
        background-color: var(--secondary-color);
        border-radius: 15px;
      }

      .counter-item {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .counter-number {
        font-size: 2.5rem;
        font-weight: 700;
        color: var(--primary-color);
        margin-bottom: 10px;
      }

      .counter-text {
        font-size: 1rem;
        color: var(--dark-gray);
      }

      @media (max-width: 992px) {
        .benefits {
          grid-template-columns: repeat(2, 1fr);
        }
      }

      @media (max-width: 768px) {
        .benefits {
          grid-template-columns: 1fr;
        }

        .impact-counter {
          flex-direction: column;
          gap: 30px;
        }
      }
    `,
  ],
})
export class WhyUsComponent {}
